<template>
  <div>
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado v-if="encabezado" :elementos="encabezado" :action="action" />
      <v-card class="border-card-gray">
        <v-card-text>
          <div :class="[list.length < 6 ? 'calendar' : '']" class="mt-2 ml-4 mr-4">
            <v-row>
              <v-col cols="3" md="3" sm="3" class="pt-3" v-if="filterModality">
                <branch-offices-list
                  :model="idBranchOfficeSelected"
                  v-on:triggerChange="branchOfficeSelected"
                />
              </v-col>
              <v-col cols="3" md="3" sm="3" v-if="filterDate">
                <vc-date-picker
                  color="green"
                  v-model="range"
                  is-range
                  :max-date="new Date()"
                >
                  <template v-slot="{ inputEvents }">
                    <v-text-field
                      v-on="inputEvents.start"
                      :value="rangeComputed"
                      :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'"
                      @click:append="clearCalendar"
                      :disabled-input="validData"
                      :label="labelDate"
                      single-line
                      outlinedx
                      hide-details
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  outlinedx
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                class="d-flex justify-center mt-4"
                v-if="!hideButtonAdd || $utilFront.withPermission($prm.SEND_STUDY_CAMUJAL)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      @click="sendStudy()"
                      v-bind="attrs"
                      v-on="on"
                      block
                      :disabled="!flagSendStudy"
                    >
                      <v-icon left>mdi-send</v-icon>
                      {{ addButtonText }}
                    </v-btn>
                  </template>
                  <span>{{ addButtonText }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-tabs icons-and-text centered fixed-tabs v-model="tab">
              <v-tab>
                Pendientes por enviar
                <v-icon right>mdi-clock</v-icon>
              </v-tab>
              <v-tab
                >Estudios enviados <v-icon right> mdi-checkbox-marked-circle-outline</v-icon></v-tab
              >

              <v-tab-item name="tosend">
                <v-card class="mt-12">
                  <component
                    key="tableSend"
                    :list="list"
                    :is="tableSend"
                    :search="search"
                    :currentPage="currentPage"
                    :range="range"
                    :totalCount="totalCount"
                    @beforeSending="beforeSending"
                    @openModal="openModal"
                    :clearSelected="clearSelected"
                  />
                  <v-row dense>
                    <v-col
                      cols="8"
                      md="8"
                      sm="8"
                      offset="2"
                      class="text-center"
                    >
                      <paginatesx
                        :click-handler="changePage"
                        :page-count="pageCount"
                        :page-range="1"
                        :margin-pages="1"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                      >
                      </paginatesx>
                    </v-col>
                    <v-col cols="2" md="2" sm="2" class="text-center mt-5">
                      <v-banner outlined single-line>
                        Total: {{ totalCount }}</v-banner
                      >
                    </v-col>
                  </v-row>
                </v-card></v-tab-item
              >
              <v-tab-item name="sent">
                <v-card class="mt-12">
                  <component
                    key="tableSent"
                    :list="list"
                    :is="tableSent"
                    :search="search"
                    :currentPage="currentPage"
                    :range="range"
                    :totalCount="totalCount"
                    @openModal="openModal"
                  />
                  <v-row dense>
                    <v-col
                      cols="8"
                      md="8"
                      sm="8"
                      offset="2"
                      class="text-center"
                    >
                      <paginatesx
                        :click-handler="changePage"
                        :page-count="pageCount"
                        :page-range="1"
                        :margin-pages="1"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                      >
                      </paginatesx>
                    </v-col>
                    <v-col cols="2" md="2" sm="2" class="text-center mt-5">
                      <v-banner outlined single-line>
                        Total: {{ totalCount }}</v-banner
                      >
                    </v-col>
                  </v-row>
                </v-card></v-tab-item
              >
            </v-tabs>
          </div>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialog" hide-overlay fullscreen persistent>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Información de estudio</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- <v-card-text> -->
          <component
            key="historySendInfo"
            :is="historySendInfo"
            :dataForModal="dataForModal"
            :dialog="dialog"
          />
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSummary" persistent>
        <component
          key="summaryModal"
          :is="summaryModal"
          :dialogSummary="dialogSummary"
          :summaryList="summaryList"
          @closeDialogSummary="closeDialogSummary"
        />
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import BranchOfficesList from "@/components/BranchOfficesList.vue";

export default {
  name: "CamujalView",
  components: {
    Loader,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
  },
  data() {
    return {
      labelDate: null,
      cols: "col-md-3 col-xl-3 col-sm-12",
      idBranchOffice: null,
      sending: false,
      dialog: false,
      index: -1,
      action: 1,
      tab: 0,
      list: [],
      selectfromTable: [],
      model: {},
      encabezado: null,
      tableSend: null,
      tableSent: null,
      service: null,
      search: null,
      historySendTable: null,
      historySendInfo: null,
      summaryModal: null,
      totalCount: 0,
      currentPage: 1,
      itemsPerPage: 10,
      searchDelay: null,
      pageCount: 1,
      hideButtonAdd: false,
      filterDate: false,
      filterModality: false,
      saveButtonText: "",
      addButtonText: "",
      range: null,
      idBranchOfficeSelected: null,
      saveCie10Changes: false,
      swalDialog: false,
      flagSendStudy: false,
     dataForModal: "",
      dialog: false,
      dialogSummary: false,
      clearSelected: false,
      summaryList: [],
    };
  },
  watch: {
    search(newValue, oldValue) {
      this.deleteSearchDelay();
      this.searchDelay = setTimeout(() => {
        this.currentPage = 1;
        this.listAllPagination();
      }, 400);
    },

    idBranchOfficeState() {
      this.listAllPagination();
    },

    tab: function() {
      this.list = [];
      this.listAllPagination();
    },
    selectfromTable: function() {
      if (this.selectfromTable.length == 0) {
        return (this.flagSendStudy = false);
      } else {
        this.flagSendStudy = true;
      }
    },
  },

  async mounted() {
    this.service = (await this.$route.meta.service()).default;
    this.tableSend = (await this.$route.meta.tableSend()).default;
    this.tableSent = (await this.$route.meta.tableSent()).default;
    this.historySendTable = (await this.$route.meta.historySendTable()).default;
    this.historySendInfo = (await this.$route.meta.historySendInfo()).default;
    this.summaryModal = (await this.$route.meta.summaryModal()).default;
    this.encabezado = this.$route.meta.header;
    this.hideButtonAdd = this.$route.meta.hideButtonAdd || false;
    this.filterDate = this.$route.meta.filterDate || false;
    this.filterModality = this.$route.meta.filterModality || false;
    this.saveButtonText = this.$route.meta.saveButtonText || "guardar";
    this.addButtonText = this.$route.meta.addButtonText || "Agregar";
    this.labelDate = this.$route.meta.labelDate || "Seleccione fecha";
    this.listAllPagination();
  },
  computed: {
    ...mapState(["idBranchOfficeState"]),
    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${this.$utilFront.formatDate(
        this.range.start
      )} al ${this.$utilFront.formatDate(this.range.end)}`;
    },
    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }
      this.listAllPagination();
      return true;
    },
  },
  methods: {
    confirmationSave() {
      this.saveCie10Changes = true;
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea guardar el registro actual?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.saveCie10Changes = false;
          this.swalDialog = false;
          this.doAction();
        } else {
          this.swalDialog = false;
        }
      });
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllPagination();
    },
    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    deleteSearchDelay() {
      if (this.searchDelay != null) {
        clearTimeout(this.searchDelay);
        this.searchDelay = null;
      }
    },
    listAllPagination() {
      this.selectfromTable = [];
      this.sending = true;
      let params = {
        search: this.search,
        maxResults: this.itemsPerPage,
        page: this.currentPage,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      if (this.$utilFront.nonEmpty(this.range)) {
        params.start = this.$utilFront.startOfDay(this.range.start);
        params.end = this.$utilFront.endOfDay(this.range.end);
      }
      switch (this.tab) {
        case 0:
          this.service
            .listAllPaginationtoSend(params)
            .then((res) => {
              this.sending = false;
              let { list, count } = res.data;
              this.list = list;
              this.totalCount = count;
              this.pageCount = Math.ceil(count / this.itemsPerPage);
              if (
                count > 0 &&
                this.$utilFront.isEmptyList(list) &&
                this.currentPage > 1
              ) {
                this.changePage(1);
              }
            })
            .catch((e) => {
              this.sending = false;
              this.$utilFront.errorhttp(e);
            });
          break;
        case 1:
          this.service
            .listAllPaginationSent(params)
            .then((res) => {
              this.sending = false;
              let { list, count } = res.data;
              this.list = list;
              this.totalCount = count;
              this.pageCount = Math.ceil(count / this.itemsPerPage);
              if (
                count > 0 &&
                this.$utilFront.isEmptyList(list) &&
                this.currentPage > 1
              ) {
                this.changePage(1);
              }
            })
            .catch((e) => {
              this.sending = false;
              this.$utilFront.errorhttp(e);
            });
          break;
      }
    },
    sendStudy() {
      let params = this.selectfromTable;
      if (!this.sending) {
        this.sending = true;
        this.service
          .sendStudy(params)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;

            if (status == 200) {
              this.summaryList = data;
              this.dialogSummary = true;
            } else {
              data = data || "Ocurrió un error durante el envio.";
              this.$utilFront.notifications(data, "ERROR");
            }
            this.clearSelected = true;
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    clearCalendar() {
      this.range = "";
      this.listAllPagination();
    },
    beforeSending(selectlist) {
      this.selectfromTable = selectlist;
    },
    openModal(flag, data) {
      this.dialog = flag;
      this.dataForModal = data;
    },
    closeDialogSummary(flag) {
      this.dialogSummary = flag;
      this.clearSelected = flag;
      this.listAllPagination();
    },
  },
};
</script>
